import Model from "./base/model";

class SimulationTableTub extends Model{
  resourceName() {
    return "simulation_table_tub";
  }

  fields() {
    return {
      simulation_table_id: "",
      state_id: "",
      state: "",
      states: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableTub();
